import React from 'react';
import {
  lang,
  useLanguage,
  scssVariables as variables,
  remFontCss as mainRemFontCss,
  convertMobileStyle
} from 'src/helpers';
import LANG_CONST from '../../helpers/lang/const';

export const MCText = React.memo(
  ({
    primary,
    heading,
    text,
    textLight,
    error,
    placeholder2,
    secondary,
    quaternary,
    septenary,
    white,
    weight = 400,
    size = 18,
    lineHeight,
    flex,
    label,
    style = {},
    children,
    numberOfLines,
    remFontCss = mainRemFontCss,
    ...props
  }) => {
    useLanguage();
    // default styles: medium, heading
    let attributes = {
      primary,
      heading,
      text,
      'text-light': textLight,
      error,
      secondary,
      quaternary,
      placeholder2,
      septenary,
      white
    };
    let color = Object.keys(attributes).find((k) => !!attributes[k]) || 'heading';

    let family = weight > 600 ? 'bold' : weight > 400 ? 'medium' : 'regular';

    let styles = {
      color: variables['colors-mc-' + color],
      fontFamily: variables['fonts-mc-' + family],
      fontWeight: weight,
      fontSize: remFontCss(size),
      lineHeight: remFontCss(lineHeight || size + 6) + 'px',
      maxWidth: '100%',
      ...convertMobileStyle(style)
    };

    if (flex) styles.flex = 1;

    if (!children) children = lang.t(label);

    if (numberOfLines) {
      styles.overflow = 'hidden';
      styles.textOverflow = 'ellipsis';
      styles.display = '-webkit-box';
      styles.WebkitLineClamp = numberOfLines;
      styles.WebkitBoxOrient = 'vertical';
    }

    return (
      <pre style={styles} {...props}>
        {children}
      </pre>
    );
  }
);
MCText.displayName = 'MCText';

const splitCamelCase = (str) => {
  return str
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .replace(/ ([A-Z])/, (m) => ' ' + m[1].toLowerCase());
};

export const MCError = ({ error, label, mcTextProps = {} }) => {
  let formattedLabel = (label + '').replace(/\.{3}/g, '');
  if (typeof label === 'string') {
    formattedLabel = splitCamelCase(label);
  }
  if (error?.includes('is required')) {
    error = lang.t(LANG_CONST.validation.required, { label: lang.t(formattedLabel) });
  } else if (error?.includes('is invalid')) {
    error = lang.t(LANG_CONST.validation.invalid, { label: lang.t(formattedLabel) });
  }
  if (typeof error === 'string' && error.length > 0) {
    error = error.replace(/undefined/g, 'Field');
    error = error.replace(/null/g, 'Field');
    error = error.charAt(0).toUpperCase() + error.slice(1);
  }

  console.log('MCError:', error);

  return (
    <MCText error size={18} {...mcTextProps}>
      {error}
    </MCText>
  );
};
